/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Storage_ErrorInputs */



/**
* | output |
* | --- |
* | "ERROR: Unable to publish \| Access to storage denied." |
*
* @param {Iconik_Publish_Storage_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_storage_error = /** @type {((inputs?: Iconik_Publish_Storage_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Storage_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ERREUR : Impossible de publier | Acces au stockage refuse.")
	if (locale === "de") return /** @type {LocalizedString} */ ("FEHLER: Veröffentlichung nicht möglich | Zugriff auf den Speicher verweigert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("ERRORE: Impossibile pubblicare | Accesso all'archiviazione negato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ОШИБКА: Невозможно опубликовать | Доступ к хранилищу запрещен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("ERROR: No se puede publicar | Acceso al almacenamiento denegado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误：无法发布 | 存储访问被拒绝。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー: 公開できません | ストレージへのアクセスが拒否されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटि: प्रकाशित करने में असमर्थ | संग्रहण तक पहुंच अस्वीकृत।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ERRO: Não foi possível publicar | Acesso ao armazenamento negado.")
	return /** @type {LocalizedString} */ ("ERROR: Unable to publish | Access to storage denied.")
});